export const testRoute = [{
  path: 'tests',
  component: () => import('../../../components/router-view'),
  children: [
    {
      path: '',
      name: 'AdminTests',
      component: () => import('../../../components/Admin/Test'),
      meta: {
        access: ['admin', 'teacher', 'examiner']
      }
    },
    {
      path: 'create',
      name: 'AdminCreateTest',
      component: () => import('../../../components/Admin/Test/create'),
      meta: {
        access: ['admin', 'teacher', 'examiner']
      }
    },
    {
      path: 'edit/:id',
      name: 'AdminEditTest',
      component: () => import('../../../components/Admin/Test/edit'),
      meta: {
        access: ['admin', 'teacher', 'examiner']
      }
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/router/admin/module/test.js